import { CircleListItem } from './../circle-list/cart-list.types';
import { Component, OnDestroy, OnInit, inject, ChangeDetectionStrategy } from "@angular/core";
import { BroadcastService, CacheScope, ClientSideCacheService, FrontendContextService, GlobalConfigService } from 'root/services';
import { Subscription} from 'rxjs';
import { Router } from '@angular/router';
import { BulletinRecentItemViewModel } from 'root/services/../models/bulletin-recent-item-view-model';
import { HttpCancellactionService } from 'root/services/http-cancellation/http-cancellation.service';

import { ResourceStringComponent } from 'root/shared/components/localization/resource-string/resource-string.component';
import { MibpCircleListComponent } from 'root/modules/home/modules/home-dashboard/components/circle-list/circle-list.component';
import { EcommerceRouterLinkDirective } from 'root/directives/ecommerce-router-link/ecommerce-router-link.directive';
import { bulletinFnListRecent } from "root/mibp-openapi-gen/fn/bulletin/bulletin-fn-list-recent";
import { MibpApiService } from "root/mibp-openapi-gen/mibp-api.service";

@Component({
  selector: 'mibp-dashboard-latest-bulletins',
  templateUrl: './dashboard-latest-bulletins.component.html',
  styleUrls: ['./dashboard-latest-bulletins.component.scss'],
  providers: [HttpCancellactionService],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [ResourceStringComponent, MibpCircleListComponent, EcommerceRouterLinkDirective]
})
export class MibpDashboardLatestBulletinsComponent implements OnInit, OnDestroy {
    private mibpApiService = inject(MibpApiService);
  private router = inject(Router);
  private frontendContext = inject(FrontendContextService);
  private cache = inject(ClientSideCacheService);
  private broadcast = inject(BroadcastService);
  private globalConfig = inject(GlobalConfigService);
  private httpCancellation = inject(HttpCancellactionService);


  isLoading = false;
  hasError = false;
  actAsSub: Subscription;
  bulletins: CircleListItem<BulletinRecentItemViewModel>[];
  isDynamicdashboard = false;

  constructor() {}

  async load(): Promise<void> {
    this.isLoading = true;
    this.hasError = false;
    try {
      const bulletins = await this.httpCancellation.singleValueFrom(this.mibpApiService.invoke(bulletinFnListRecent, {take : 8}));
      this.bulletins = bulletins?.map<CircleListItem<BulletinRecentItemViewModel>>(bulletin => {
        return {
          date: new Date(bulletin?.createdDate),
          tooltip: bulletin?.title,
          data: bulletin
        };
      });

      this.isLoading = false;

    } catch (error) {
      this.isLoading = false;
      this.hasError = true;
    }
  }

  ngOnInit(): void {
    this.actAsSub = this.broadcast.deliverySequence.subscribe(() => this.load());
    this.isDynamicdashboard = this.globalConfig.activateDynamicDashboard;
  }

  getBulletinDetails(bulletinId: any, canEdit:any): void {
    if(bulletinId)
    {
      this.cache.add('Bulletin.CanEdit', canEdit, null, CacheScope.MemoryStorage);
      const url = this.frontendContext.Navigation.ensureUrlLanguage(`/bulletins/details/${bulletinId}`);
      this.router.navigateByUrl(url);
    }
  }

  ngOnDestroy(): void {
    this.actAsSub?.unsubscribe();
  }

}
